import { createContext, useContext, useEffect, useState } from "react";
import { api } from "../lib/api";

const STORAGE_KEY = "pt_currency";
const CurrencyContext = createContext(null);

export function CurrencyProvider({ children }) {
  // null = loading, "BR" or "EU"
  const [currency, setCurrencyState] = useState(null);
  const [autoDetected, setAutoDetected] = useState(null);

  useEffect(() => {
    const stored = localStorage.getItem(STORAGE_KEY);
    if (stored === "BR" || stored === "EU") {
      setCurrencyState(stored);
      // Still detect in background to inform the user if needed
      api.get("/geo").then((r) => setAutoDetected(r.data.currency)).catch(() => {});
      return;
    }
    // Auto-detect
    api
      .get("/geo")
      .then((r) => {
        const c = r.data.currency === "EU" ? "EU" : "BR";
        setCurrencyState(c);
        setAutoDetected(c);
      })
      .catch(() => setCurrencyState("BR"));
  }, []);

  const setCurrency = (c) => {
    if (c !== "BR" && c !== "EU") return;
    localStorage.setItem(STORAGE_KEY, c);
    setCurrencyState(c);
  };

  const clearOverride = () => {
    localStorage.removeItem(STORAGE_KEY);
    if (autoDetected) setCurrencyState(autoDetected);
  };

  return (
    <CurrencyContext.Provider value={{ currency: currency || "BR", setCurrency, autoDetected, clearOverride }}>
      {children}
    </CurrencyContext.Provider>
  );
}

export function useCurrency() {
  const ctx = useContext(CurrencyContext);
  return ctx || { currency: "BR", setCurrency: () => {}, autoDetected: null, clearOverride: () => {} };
}
